
import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import ApiUiController from "../../../controller/ApiUiController";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import { FaPrint } from "react-icons/fa";
import IndividualLeadStatus from "./IndividualLeadStatus";
import IndividualLeadSource from "./individualLeadSource";
import IndividualLeadsAllocated from "./individualLeadsAllocated";
import IndividualCallReport from "./IndividualCallReport";
import InvidualCallTalkTimeReport from "./IndividualCallTalktimeReport";
import IndividualCallFeedbackReport from "./IndividualCallFeedback";
import IndividualCallInOut from "./IndividualCallInOut";
import IndividualMeeetingReport from "./IndividualMeetingReport";
import IndividualMeetingFeedback from "./IndividualMeetingFeedback";
import IndividualLeadsByProject from "./IndividualLeadsByProject";
import IndividualMeetingByProject from "./IndividualMeetingByProject";
import IndividualLeadsByPropertyType from "./IndividualPropertyByConfiguration";
import IndividualLeadsByRentSale from "./IndividualLeadsByRentSale";
import IndividualReportBoxes from "./IndividualReportBoxes";
// import IndividualpropertyBookingBySalesPerson from "./BookingsBySalesPerson";

class IndividualSalesReportPage extends React.Component {
  constructor(props) {
    super(props);

    const queryParams = new URLSearchParams(this.props.location.search);
    this.selectedOptions = queryParams.get("options") || "";
    this.dateCondition = queryParams.get("dateCondition") || "between";
    this.dateFrom = (queryParams.get("dateFrom") || "").replace("+", " ");
    this.dateTo = (queryParams.get("dateTo") || "").replace("+", " ");
    this.options = reactLocalStorage.getObject(Constants.Model)?.user?.options || [];
    this.selectedIds = this.selectedOptions.split("~").filter(Boolean) || [];
    this.state = {
      users: {},
      inApiCall: true,
    };
  }

  componentDidMount() {
    // Map users
    const activeStatuses = [Constants.Active, Constants.AlwaysActive].filter(Boolean);
    const users = (this.options || [])
      .filter(({ status }) => activeStatuses.includes(status))
      .reduce((acc, { value, name }) => {
        acc[value] = name || "Unknown";
        return acc;
      }, {});

    // Update state to stop loading and set users
    this.setState({ users, inApiCall: false });
  }

  render() {
    const { inApiCall } = this.state;
    const names = this.selectedIds.map((id) => this.state.users[id] || "Unknown").join(", ");
    const datePeriod = `${this.dateFrom.split(" ")[0]} to ${this.dateTo.split(" ")[0]}`;
    const filters = { dateCondition: this.dateCondition, dateFrom: this.dateFrom, dateTo: this.dateTo, selectedIds: this.selectedIds };
    const [startDate, endDate] = datePeriod.split(" to ");
    const startDateFormat = `${startDate.split("-")[2]}-${startDate.split("-")[1]}-${startDate.split("-")[0]}`;
    const endDateFormat = `${endDate.split("-")[2]}-${endDate.split("-")[1]}-${endDate.split("-")[0]}`;
    const datePeriodFormat = `${startDateFormat} to ${endDateFormat}`;
    return (
      <ApiUiController inApiCall={inApiCall}>
        <div className="m-4">
          <h1 className="text-center">Individual Performance Report</h1>
          <hr />
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <p><strong>Sales Executives:</strong> {names || "N/A"}</p>
              <p><strong>Date Period:</strong> {datePeriodFormat}</p>
            </div>
            <button
              className="btn btn-primary d-flex align-items-center"
              onClick={() => window.print()}
            >
              <FaPrint className="m-2" />
              Print
            </button>
          </div>
          <IndividualReportBoxes filters={filters} />
          {/* <IndividualLeadsAllocated filters={filters} /> */}
          <IndividualLeadStatus filters={filters} />
          <IndividualLeadSource filters={filters} />
          <IndividualLeadsByProject filters={filters} />
          {/* <IndividualCallReport filters={filters} /> */}
          {/* <InvidualCallTalkTimeReport filters={filters} /> */}
          <IndividualCallFeedbackReport filters={filters} />
          {/* <IndividualCallInOut filters={filters} /> */}
          {/* <IndividualMeeetingReport filters={filters} /> */}
          <IndividualMeetingFeedback filters={filters} />
          <IndividualMeetingByProject filters={filters} />
          <IndividualLeadsByPropertyType filters={filters} />
          <IndividualLeadsByRentSale filters={filters} />
          {/* <IndividualpropertyBookingBySalesPerson filters = {filters}/> */}
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(IndividualSalesReportPage);


//monthwise report 
// SELECT DATE_FORMAT(created_date, '%Y-%m') AS month, SUM(total) AS total_sales FROM sales_order_model WHERE responsible_person LIKE ('%1%') AND status = 1 GROUP BY DATE_FORMAT(created_date, '%Y-%m') ORDER BY DATE_FORMAT(created_date, '%Y-%m');
